// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6031":"3b1ba721d857ce6e","7908":"c4a7adc04b074318","8765":"5eabbff19bf599af"}[chunkId] + ".css";
};